import React from 'react'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'
import './themeChosen.css'
import switchTheme from '../../theme/theme'

// Redux
import { connect } from "react-redux";
import { currentTheme } from "../../redux/actions";

class ThemeChosen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: localStorage.getItem('theme') === 'dark'
        }
    }

    componentDidMount = () => {
        this.props.currentTheme(this.state.value ? 'dark' : 'light')
    }

    handleToggle = (value) => {
        setTimeout(() => {
            this.setState({ value: !value })
            switchTheme(this.state.value ? 'dark' : 'light')
            this.props.currentTheme(this.state.value ? 'dark' : 'light')

        }, 100);

    }
    render() {
        return (
            <div className='theme-chosen-container'>
                <label>
                    <Toggle
                        onChange={() => this.handleToggle(this.state.value)}
                        checked={this.state.value}
                        className='dark-toggle'
                        icons={{
                            checked: icon('moon-icon'),
                            unchecked: icon('sun-icon'),
                        }}
                    />
                </label>
            </div>
        )
    }
}


const icon = (type) => {
    return <div className={`theme-chosen-icon ${type}`} />
}


const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
        currentTheme: data => dispatch(currentTheme(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeChosen);
